import {Skeleton} from '@raison/ui-kit';
import React from 'react';

export function ReportsPageSkeleton() {
    return (
        <div className='flex flex-1 flex-col'>
            <div className='flex flex-1 flex-col gap-6'>
                <InputSkeleton />
                <RadioSkeleton />
                <InputSkeleton />
                <RadioSkeleton />
                <InputSkeleton />
                <RadioSkeleton />
            </div>
            <div className='flex flex-col gap-4'>
                <div className='gap gap- flex h-10 flex-col items-center justify-center gap-[.375rem]'>
                    <Skeleton width={256} height={14} borderRadius={6} />
                    <Skeleton width={128} height={14} borderRadius={6} />
                </div>
                <Skeleton width={'100%'} height={48} borderRadius={16} />
            </div>
        </div>
    );
}

function InputSkeleton() {
    return (
        <div className='flex flex-col gap-2'>
            <div className='h-4'>
                <Skeleton width={88} height={12} borderRadius={6} />
            </div>
            <div className='flex h-11 items-center justify-between gap-2 rounded-sm border border-solid border-neutral-40 px-3'>
                <Skeleton width={100} height={12} borderRadius={6} />
                <Skeleton circle={12} />
            </div>
        </div>
    );
}

function RadioSkeleton() {
    return (
        <div className='flex flex-col gap-2'>
            <div className='h-4'>
                <Skeleton width={64} height={12} borderRadius={6} />
            </div>
            <div className='flex'>
                <div className='flex flex-1 items-center gap-2 py-2'>
                    <div className='size-5 rounded-full border border-solid border-neutral-40' />
                    <Skeleton width={96} height={14} borderRadius={6} />
                </div>
                <div className='flex flex-1 items-center gap-2 py-2'>
                    <div className='size-5 rounded-full border border-solid border-neutral-40' />
                    <Skeleton width={96} height={14} borderRadius={6} />
                </div>
            </div>
        </div>
    );
}
